var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _g, _path2, _rect7, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsOutlook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 20,
    height: 28,
    rx: 2,
    fill: "#1066B5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 20,
    height: 28,
    rx: 2,
    fill: "url(#paint0_linear_915_183)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3,
    width: 10,
    height: 10,
    fill: "#32A9E7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13,
    width: 10,
    height: 10,
    fill: "#167EB4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 13,
    width: 10,
    height: 10,
    fill: "#32A9E7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 3,
    width: 10,
    height: 10,
    fill: "#58D9FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_915_183",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 12,
    width: 24,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H30C31.1046 12 32 12.8954 32 14V26C32 27.1046 31.1046 28 30 28H10C8.89543 28 8 27.1046 8 26V12Z",
    fill: "url(#paint1_linear_915_183)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_915_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 12V16H30V12H32Z",
    fill: "#135298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 28V14L7 28H32Z",
    fill: "url(#paint2_linear_915_183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 28V14L33 28H8Z",
    fill: "url(#paint3_linear_915_183)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10C8 8.34315 9.34315 7 11 7H17C18.6569 7 20 8.34315 20 10V22C20 23.6569 18.6569 25 17 25H8V10Z",
    fill: "black",
    fillOpacity: 0.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 18,
    height: 18,
    rx: 2,
    fill: "url(#paint4_linear_915_183)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.0693V13.903C14 11.0222 11.9272 9 9.01582 9C6.08861 9 4 11.036 4 13.9307V14.097C4 16.9778 6.07278 19 9 19C11.9114 19 14 16.964 14 14.0693ZM11.6424 14.097C11.6424 16.0083 10.5665 17.1579 9.01582 17.1579C7.46519 17.1579 6.37342 15.9806 6.37342 14.0693V13.903C6.37342 11.9917 7.44937 10.8421 9 10.8421C10.5348 10.8421 11.6424 12.0194 11.6424 13.9307V14.097Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_915_183",
    x1: 10,
    y1: 14,
    x2: 30,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_915_183",
    x1: 8,
    y1: 24.7692,
    x2: 32,
    y2: 24.7692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B366F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2657B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_915_183",
    x1: 32,
    y1: 21,
    x2: 8,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44DCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#259ED0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_915_183",
    x1: 8,
    y1: 21,
    x2: 32,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#259ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44DCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_915_183",
    x1: 0,
    y1: 14,
    x2: 18,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsOutlook);
export default __webpack_public_path__ + "static/media/ms-outlook.72b162b69da12d4705cc88801e5c0f8f.svg";
export { ForwardRef as ReactComponent };